import { Component } from '@angular/core';
import { StandaloneDefaultImports } from '../../ui/standalone-default-imports';
import { SpinnerDialengaComponent } from '../spinner-dialenga/spinner-dialenga.component';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';

@Component({
    selector: 'dui-notifications',
    standalone: true,
    imports: [...StandaloneDefaultImports, SpinnerDialengaComponent],
    templateUrl: './dui-notifications.component.html',
    animations: [
        trigger('flyInOut', [
            state(
                'inactive',
                style({
                    opacity: 0
                })
            ),
            transition(
                'inactive => active',
                animate(
                    '400ms ease-out',
                    keyframes([
                        style({
                            opacity: 0
                        }),
                        style({
                            opacity: 1
                        })
                    ])
                )
            ),
            transition(
                'active => removed',
                animate(
                    '400ms ease-out',
                    keyframes([
                        style({
                            opacity: 1
                        }),
                        style({
                            transform: 'translateY(40px)',
                            opacity: 0
                        })
                    ])
                )
            )
        ])
    ]
})
export class DuiNotificationsComponent extends Toast {
    // Section: PRIVATE PROPERTIES
    //----------------------------------------------------------------------
    private iconClassMap: { [key: string]: string } = {
        'toast-success': 'toast-icon icon icon-ok',
        'toast-error': 'toast-icon icon icon-error',
        'toast-info': 'toast-icon icon icon-info',
        'toast-warning': 'toast-icon icon icon-alert'
    };

    private iconSmallClassMap: { [key: string]: string } = {
        'toast-success': 'toast-icon icon icon-accept',
        'toast-error': 'toast-icon icon icon-error',
        'toast-info': 'toast-icon icon icon-info',
        'toast-warning': 'toast-icon icon icon-alert'
    };

    constructor(
        protected override toastrService: ToastrService,
        public override toastPackage: ToastPackage
    ) {
        super(toastrService, toastPackage);
    }

    // Section: PUBLIC METHODS
    //----------------------------------------------------------------------
    get showSpinner(): boolean {
        return this.toastPackage.config.payload?.showSpinner === true;
    }

    get iconNameClass(): string {
        const isSmall = this.toastPackage.config.payload?.isSmall === true;
        const map = isSmall ? this.iconSmallClassMap : this.iconClassMap;
        return map[this.toastPackage.toastType] || '';
    }

    action(event: Event) {
        event.stopPropagation();
        this.toastPackage.triggerAction();
        return false;
    }
}
